define("settings/components/credit-usage", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "moment-timezone", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _tracking, _emberConcurrency, _momentTimezone, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"moment-timezone",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.canDisplay}}
    <div class="u--flex u--flex__col u--flex__grow--1 qa--settings__section--creditsUsed">
      <div class="u--flex u--flex__grow--1 u--flex__justify--between">
        <h2 class="tAC--section__title">{{t "account.overview.credits.title"}}</h2>
        {{#unless this.isMobileSubscription}}
          {{#if this.canAddAiCredits}}
            <Shared::Button::Upgrade
              @feature="aiCredits"
              @isSimplifiedCheckout={{true}}
              @seamlessCheckoutSuccessCallback={{perform this.loadCreditUsage}}
              @text={{t "account.overview.credits.manage"}}
              @trialText={{t "account.overview.credits.manage"}}
              @variant="outline"
              class="qa--settings__manageCreditsBtn"
            />
          {{else}}
            <Shared::Button::Upgrade
              @feature="additionalAiCreditsOnStarter"
              @seamlessCheckoutSuccessCallback={{perform this.loadCreditUsage}}
            />
          {{/if}}
        {{/unless}}
      </div>
      <hr class="tAC--section__divider" />
      <div class="u--flex u--flex__col u--flex__grow--1">
        {{! Usage Count }}
        <p class="u--text--md u--m__0 qa--settings__credits">
          {{t "shared_words.credits"}}
          <span class="u--float--right u--text--base u--text--light qa--settings__creditsUsed">
            {{t "account.overview.credits.usage" total=this.totalCredits used=this.usedCredits}}
          </span>
        </p>
        {{! Progrees Bar }}
        <div class="o--progress u--m__tb">
          <span class="o--progress__line" style={{html-safe this.percentCSS}}></span>
        </div>
        {{! Usage Details }}
        <div class="u--row u--row--noCollapse">
          <div class="u--col__6">
            <p class="u--text--light u--text--sm">
              {{t "account.overview.post_usage.usage_reset" count=this.usageReset}}
            </p>
          </div>
          <div class="u--col__6">
            {{#if (or this.isMobileSubscription (not this.canAddAiCredits))}}
              <p class="u--text--light u--text--sm u--text--right qa--settings__totalCreditsInPlanAndExtra">
                {{t "account.overview.credits.breakdown_no_addons" plan=this.planName planAmount=this.includedCredits}}
              </p>
            {{else}}
              <p class="u--text--light u--text--sm u--text--right qa--settings__totalCreditsInPlanAndExtra">
                {{t
                  "account.overview.credits.breakdown"
                  addOnAmount=this.additionalCredits
                  plan=this.planName
                  planAmount=this.includedCredits
                }}
              </p>
            {{/if}}
          </div>
        </div>
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "523tsZz/",
    "block": "[[[41,[30,0,[\"canDisplay\"]],[[[1,\"  \"],[10,0],[14,0,\"u--flex u--flex__col u--flex__grow--1 qa--settings__section--creditsUsed\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--flex u--flex__grow--1 u--flex__justify--between\"],[12],[1,\"\\n      \"],[10,\"h2\"],[14,0,\"tAC--section__title\"],[12],[1,[28,[35,1],[\"account.overview.credits.title\"],null]],[13],[1,\"\\n\"],[41,[51,[30,0,[\"isMobileSubscription\"]]],[[[41,[30,0,[\"canAddAiCredits\"]],[[[1,\"          \"],[8,[39,3],[[24,0,\"qa--settings__manageCreditsBtn\"]],[[\"@feature\",\"@isSimplifiedCheckout\",\"@seamlessCheckoutSuccessCallback\",\"@text\",\"@trialText\",\"@variant\"],[\"aiCredits\",true,[28,[37,4],[[30,0,[\"loadCreditUsage\"]]],null],[28,[37,1],[\"account.overview.credits.manage\"],null],[28,[37,1],[\"account.overview.credits.manage\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[39,3],null,[[\"@feature\",\"@seamlessCheckoutSuccessCallback\"],[\"additionalAiCreditsOnStarter\",[28,[37,4],[[30,0,[\"loadCreditUsage\"]]],null]]],null],[1,\"\\n\"]],[]]]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,\"hr\"],[14,0,\"tAC--section__divider\"],[12],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--flex u--flex__col u--flex__grow--1\"],[12],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"u--text--md u--m__0 qa--settings__credits\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_words.credits\"],null]],[1,\"\\n        \"],[10,1],[14,0,\"u--float--right u--text--base u--text--light qa--settings__creditsUsed\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.credits.usage\"],[[\"total\",\"used\"],[[30,0,[\"totalCredits\"]],[30,0,[\"usedCredits\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"o--progress u--m__tb\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"o--progress__line\"],[15,5,[28,[37,5],[[30,0,[\"percentCSS\"]]],null]],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.overview.post_usage.usage_reset\"],[[\"count\"],[[30,0,[\"usageReset\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n\"],[41,[28,[37,6],[[30,0,[\"isMobileSubscription\"]],[28,[37,7],[[30,0,[\"canAddAiCredits\"]]],null]],null],[[[1,\"            \"],[10,2],[14,0,\"u--text--light u--text--sm u--text--right qa--settings__totalCreditsInPlanAndExtra\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"account.overview.credits.breakdown_no_addons\"],[[\"plan\",\"planAmount\"],[[30,0,[\"planName\"]],[30,0,[\"includedCredits\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,2],[14,0,\"u--text--light u--text--sm u--text--right qa--settings__totalCreditsInPlanAndExtra\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"account.overview.credits.breakdown\"],[[\"addOnAmount\",\"plan\",\"planAmount\"],[[30,0,[\"additionalCredits\"]],[30,0,[\"planName\"]],[30,0,[\"includedCredits\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"t\",\"unless\",\"shared/button/upgrade\",\"perform\",\"html-safe\",\"or\",\"not\"]]",
    "moduleName": "settings/components/credit-usage.hbs",
    "isStrictMode": false
  });
  let CreditUsageComponent = _exports.default = (_class = class CreditUsageComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
      _initializerDefineProperty(this, "remainingCredits", _descriptor4, this);
      _initializerDefineProperty(this, "hasError", _descriptor5, this);
      _defineProperty(this, "loadCreditUsage", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            const remainingCredits = yield this.auth.currentAccount.usagesRemaining({
              feature: 'ai_credits'
            });
            this.remainingCredits = remainingCredits?.usages_remaining ?? 0;
          } catch (error) {
            this.hasError = true;
            this.errors.log('loadCreditUsage Error: ', error);
          }
        }
      }), null, "loadCreditUsage", null));
      this.loadCreditUsage.perform();
    }
    get canDisplay() {
      return !this.loadCreditUsage.isRunning && !this.hasError;
    }
    get canAddAiCredits() {
      return Boolean(this.subscriptions.subscriptionPlan?.canAddAiCredits);
    }
    get totalCredits() {
      return this.additionalCredits + this.includedCredits;
    }
    get additionalCredits() {
      return this.subscriptions.subscription?.additionalAiCredits ?? 0;
    }
    get includedCredits() {
      return this.subscriptions.subscriptionPlan?.numberOfAiCredits ?? 0;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get usedCredits() {
      return Math.max(this.totalCredits - this.remainingCredits, 0);
    }
    get percentCSS() {
      const width = Math.min(100, this.usedCredits / this.totalCredits * 100);
      return `width: ${width}%`;
    }
    get planName() {
      return this.subscriptions.subscriptionPlan?.displayName;
    }
    get usageReset() {
      return (0, _momentTimezone.default)().endOf('month').diff((0, _momentTimezone.default)(), 'days');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "remainingCredits", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CreditUsageComponent);
});